// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bfq_a"};